import * as React from 'react';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { Theme, WithStyles, withStyles, createStyles, LinearProgress } from "@material-ui/core";
import { } from '../HOC/Transition';
import { PaymentsAPI, Package, APIError } from 'src/api'
import WelcomeHeader from '../Header/WelcomeHeader';
import strings from 'src/strings';
import { defaultView, DefaultView } from '../HOC';

class PricingState {
    loading: boolean;
    packages: Package[]
}

class Pricing extends React.Component<WithStyles<typeof styles> & DefaultView, PricingState> {

    constructor(props: WithStyles<typeof styles> & DefaultView) {
        super(props);
        this.state = {
            loading: false,
            packages: []
        }
    }

    componentDidMount() {
        this.setState({ loading: true })
        PaymentsAPI.getPackages().then(packages => {
            this.setState({
                loading: false, packages: packages.sort((it1, it2) => {
                    return it1.order - it2.order
                }).map(it => {
                    it.pricing_infos = it.pricing_infos.sort((it1, it2) => {
                        return it2.interval.localeCompare(it1.interval)
                    })
                    return it
                })
            })
        }).catch(() => {
            this.props.showToast('error', strings.error_generic)
            this.setState({ loading: false })
        })
    }

    private isCurrentPlan(planId: string) {
        return this.props.user && this.props.user.hasValidSubscription() && this.props.user.getValidSubscription()!.package.id == planId
    }

    private isDowngrade(plan: Package) {
        if (this.props.user && this.props.user.hasValidSubscription()) {
            return this.props.user!.getValidSubscription()!.package.num_clients > plan.num_clients;
        }
        return false
    }

    public render() {
        const { classes } = this.props
        return (
            <React.Fragment>
                {this.state.loading && <LinearProgress color={'secondary'} />}
                <WelcomeHeader />
                <CssBaseline />
                <main className={classes.layout}>
                    {/* Hero unit */}
                    <div className={classes.heroContent}>
                        <Typography component="h1" variant="h2" align="center" color="textPrimary" gutterBottom>
                            Pricing
                        </Typography>
                        <Typography variant="h6" align="center" color="textSecondary" component="p">
                            {strings.pricing_description}
                        </Typography>
                    </div>
                    {/* End hero unit */}
                    <Grid container spacing={10} alignItems="center" justify="center">
                        {this.state.packages.map(tier => (
                            // Enterprise card is full width at sm breakpoint
                            <Grid item key={tier.name} xs={4}>
                                <Card>
                                    <CardHeader
                                        title={tier.name}
                                        titleTypographyProps={{ align: 'center' }}
                                        subheaderTypographyProps={{ align: 'center' }}
                                        className={classes.cardHeader}
                                    />
                                    <CardContent>
                                        <div className={classes.cardPricing}>
                                            <Typography component="h2" variant="h3" color="textPrimary">
                                                ${(tier.pricing_infos[0].amount / 100).toFixed(0)}
                                            </Typography>
                                            <Typography variant="h6" color="textSecondary">
                                                /{tier.pricing_infos[0].interval}
                                            </Typography>
                                        </div>
                                        {tier.pricing_infos.slice(1).map(info => {
                                            return <div className={classes.cardPricing} key={info.id}><Typography component="h6" variant="h6" color="textPrimary">
                                                or ${(info.amount / 100).toFixed(0)}/{info.interval}
                                            </Typography></div>
                                        })}
                                        <div className={classes.description}>
                                            {tier.pricing_infos[0].trial &&
                                                <Typography variant="subtitle1" align="center">{tier.pricing_infos[0].trial} days trial
                                                </Typography>
                                            }
                                            {tier.description.split('\n').map(line => (
                                                <Typography variant="subtitle1" align="center" key={line}>
                                                    {line}
                                                </Typography>
                                            ))}
                                        </div>
                                    </CardContent>
                                    <CardActions className={classes.cardActions}>
                                        {!this.isDowngrade(tier) && <>
                                            {this.isCurrentPlan(tier.id) && <Button fullWidth variant={'outlined'} color="secondary">
                                                {strings.current_plan}
                                            </Button>}

                                            {!(this.isCurrentPlan(tier.id)) && <Button fullWidth variant={'outlined'} color="primary" onClick={() => this.props.history.push({
                                                pathname: '/checkout',
                                                state: {
                                                    tier: tier.id,
                                                    upgrade: this.props.user && this.props.user.hasValidSubscription()
                                                }
                                            })}>
                                                {(this.props.user && this.props.user.hasValidSubscription() ? strings.upgrade : strings.get_started)}
                                            </Button>}
                                        </>}

                                    </CardActions>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </main>
            </React.Fragment >
        )
    }
}


const styles = (theme: Theme) => createStyles({
    '@global': {
        body: {
            backgroundColor: theme.palette.common.white,
        },
    },
    appBar: {
        position: 'relative',
    },
    toolbarTitle: {
        flex: 1,
    },
    layout: {
        width: 'auto',
        marginLeft: theme.spacing(3),
        marginRight: theme.spacing(3),
        [theme.breakpoints.up(900 + theme.spacing(3) * 2)]: {
            width: 900,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    heroContent: {
        maxWidth: 600,
        margin: '0 auto',
        padding: `${theme.spacing(8)}px 0 ${theme.spacing(6)}px`,
    },
    cardHeader: {
        backgroundColor: theme.palette.grey[200],
    },
    cardPricing: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'baseline',
    },
    description: {
        marginTop: theme.spacing(2),
    },
    cardActions: {
        [theme.breakpoints.up('sm')]: {
            paddingBottom: theme.spacing(2),
        },
    },
    footer: {
        marginTop: theme.spacing(8),
        borderTop: `1px solid ${theme.palette.divider}`,
        padding: `${theme.spacing(6)}px 0`,
    },
});

export default defaultView(withStyles(styles)(Pricing)) as React.ComponentClass;


// WEBPACK FOOTER //
// ./src/components/Pricing/Pricing.tsx